import {EntitetReferanseSpesifikasjon, EntitetType} from "../tjenester/ressurser/generertNg2HttpKlient";

export function somEntitetReferanseSpesifikasjon(type: EntitetType, id: string): EntitetReferanseSpesifikasjon {
    return {type: type, id: id}
}

/** Serialiserer EntitetReferanseSpesifikasjon til streng.
 * For deserialisering på javasiden via no.systemfabrikken.lederplan.resources.modell.EntitetReferanseSpesifikasjon.fromString */
export function enkodetEntitetReferanseSpesifikasjon(entitetReferanse: EntitetReferanseSpesifikasjon): string | null {
    if (!entitetReferanse) return null;
    return `${entitetReferanse.type}:${entitetReferanse.id}`;
}
